module.exports = __webpack_public_path__ + "static/media/rectangle-view-off.b38dbfd6.svg";